import usePermission from './usePermission';

const Permission = ({ allow, children }) => {
  const isAllowed = usePermission(allow);

  return children(isAllowed);
};

export default Permission;
